// extracted by mini-css-extract-plugin
module.exports = {"container":"Model_container__3WKlx","list_wrapper":"Model_list_wrapper__1Z8az","item_box":"Model_item_box__3C-zx","item_text":"Model_item_text__Q6iCk"};